import { useState } from 'react';

interface FormState {
  submitting: boolean;
  success: boolean;
  error: string;
}

export function useFormSubmit(submitAddr: string) {
  const [state, setState] = useState<FormState>({ submitting: false, success: false, error: '' });

  const reset = () => setState({ submitting: false, success: false, error: '' });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    // 蜜罐检测：若被机器人填写则伪装成功，但不提交
    const honeypotFields = ['website_alt', 'company_alt', 'phone_alt', 'mobile_alt', 'contact_alt'];
    const honeyHit = honeypotFields.some((f) => {
      const v = (data.get(f) as string) || '';
      return v.trim().length > 0;
    });

    setState({ submitting: true, success: false, error: '' });

    if (honeyHit) {
      await new Promise((r) => setTimeout(r, 600));
      form.reset();
      setState({ submitting: false, success: true, error: '' });
      return;
    }

    for (const f of honeypotFields) {
      data.delete(f);
    }

    const body = new URLSearchParams();
    data.forEach((value, key) => {
      body.append(key, String(value));
    });

    try {
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = /spam/i.test(serverMsg);

      if (!res.ok || isSpam || parsed?.code !== 'OK') {
        setState({
          submitting: false,
          success: false,
          error: serverMsg || '提交失败，请稍后重试',
        });
        return;
      }
      form.reset();
      setState({ submitting: false, success: true, error: '' });
    } catch {
      setState({ submitting: false, success: false, error: '网络异常，请检查后重试' });
    }
  };

  return { ...state, handleSubmit, reset };
}